'use strict';

import 'Datepicker';

export default class Form {
    constructor() {
        new Datepicker('#datepicker');
    }
}
